// Verbindet FormField/Field mit dem Feld darin: id, aria-describedby, aria-invalid (DESIGN §3.6.12).
import { createContext, useContext, type AriaAttributes } from 'react';

export interface FieldContextValue {
  id: string;
  /** id des sichtbaren Labels (für Felder, deren Bibliothek `aria-labelledby` selbst setzt). */
  labelId?: string;
  describedBy?: string;
  invalid: boolean;
  required?: boolean;
}

export const FieldContext = createContext<FieldContextValue | null>(null);

/** Props, die ein Feld vom umgebenden Field übernimmt; eigene Props haben Vorrang. */
export function useFieldProps(own: {
  id?: string;
  'aria-describedby'?: string;
  'aria-invalid'?: AriaAttributes['aria-invalid'];
  required?: boolean;
}) {
  const field = useContext(FieldContext);
  const describedBy = [field?.describedBy, own['aria-describedby']].filter(Boolean).join(' ');
  const invalid = own['aria-invalid'] ?? (field?.invalid ? true : undefined);
  return {
    id: own.id ?? field?.id,
    'aria-describedby': describedBy || undefined,
    'aria-invalid': invalid,
    required: own.required ?? field?.required,
    labelId: field?.labelId,
  };
}
